export { default as useUpdateGlobalCompanyTabForm } from './useUpdateGlobalCompanyTabForm';
export type { UpdateGlobalCompanyTabFormData } from './useUpdateGlobalCompanyTabForm';
